import { render, staticRenderFns } from "./collegeTree.vue?vue&type=template&id=9d0934e0&scoped=true&"
import script from "./collegeTree.vue?vue&type=script&lang=js&"
export * from "./collegeTree.vue?vue&type=script&lang=js&"
import style0 from "./collegeTree.vue?vue&type=style&index=0&id=9d0934e0&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0934e0",
  null
  
)

export default component.exports